/**
 * Formatta un numero come valuta in euro
 * @param {number} value - Il valore da formattare
 * @returns {string} Il valore formattato come valuta (es. "€ 10,00")
 */
export const formatCurrency = (value) => {
  if (value === null || value === undefined) return '-';
  
  // Converti il valore in numero se è una stringa
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  // Verifica se il valore è un numero valido
  if (isNaN(numValue)) return '-';
  
  // Formatta il numero come valuta in euro
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(numValue);
}; 